import {
    Container
} from './styles'

import {
    Title
} from '../../../components'
import { useHistory } from 'react-router-dom'

export default function Joelho(){

    const items = [
        {
            text: "Parâmetros Técnicos",
            url: "/parametrosTecnicos"
        },
        {
            text: "Posição do Paciente",
            url: "/posicaoPaciente"
        },
        {
            text: "Programação",
            url: "/linhasReferencia"
        },
        {
            text: "Reformatações Multiplanares",
            url: "/referenciasAnatomicas"
        },
        {
            text: "Protocolos de pós-processamento",
            url: "/protocolosPosProcessamento"
        },
        {
            text: "Back-up",
            url: "/backup"
        },
        {
            text: "Documentação",
            url: "/documentacao"
        }
    ]

    const history = useHistory()
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Tomografia Computadorizada Multislice do Tórax</Title>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-10">
                    {
                        items.map(item => (
                            <button
                                key={item.url}
                                className="btn btn-info btn-block"
                                onClick={
                                    () => history.push(`/tronco/torax${ item.url }`)
                                }
                            >{ item.text }</button>
                        ))
                    }
                </div>
            </div>
        </Container>
    )
}